import { authApiService } from '@/api/authApiService';
import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';

export const resendOtpCodeApi = async (): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/users/auth/otp:resend/`;

  return authApiService.POST(uri, {});
};
